export interface ApiError {
  code: string;
  message: string;
  details?: unknown;
}

export class ApiException extends Error {
  constructor(public status: number, public apiError: ApiError) {
    super(apiError.message);
  }
}

interface RequestOptions {
  method?: string;
  body?: unknown;
  query?: Record<string, string | number | undefined>;
  signal?: AbortSignal;
}

export async function api<T = unknown>(endpoint: string, options: RequestOptions = {}): Promise<T> {
  const url = new URL(endpoint, window.location.origin);
  if (options.query) {
    for (const [k, v] of Object.entries(options.query)) {
      if (v !== undefined) url.searchParams.set(k, String(v));
    }
  }

  const init: RequestInit = {
    method: options.method ?? 'GET',
    credentials: 'include',
    signal: options.signal,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (options.body !== undefined) init.body = JSON.stringify(options.body);

  const res = await fetch(url.toString(), init);

  if (!res.ok) {
    const body = await res
      .json()
      .catch(() => ({ error: { code: 'INVALID_RESPONSE', message: res.statusText } }));
    throw new ApiException(
      res.status,
      body.error ?? { code: 'UNKNOWN', message: res.statusText },
    );
  }

  const data = await res.json();
  return data.data as T;
}
